import React from "react";
import { cn } from "../lib/utils";

const SOURCE_LABELS = {
  HousingAnywhere: "HousingAnywhere",
  "huurwoningen.com": "Huurwoningen.com",
  "Direct van makelaar": "Makelaar (direct)",
  woningalert: "WoningAlert",
};

export function sourceLabel(source) {
  if (!source) return "WoningAlert";
  return SOURCE_LABELS[source] || source;
}

export function SourceBadge({ source, className }) {
  return (
    <span
      data-testid="listing-source"
      className={cn(
        "inline-flex items-center gap-1 rounded-full bg-slate-100 px-2.5 py-1 text-[11px] font-semibold text-slate-500",
        className
      )}
    >
      Bron: {sourceLabel(source)}
    </span>
  );
}
